import { all, call, put } from "redux-saga/effects"
import {
  getRedditConversionsSuccess,
  getRedditConversionsFailed,
} from "../actions"
import { backervoiceApi } from "../apis"

export default function* handleRedditConversions({ payload }) {
  try {
    const [purchaseData, pageVisitData] = yield all([
      call(backervoiceApi.purchaseRedditConversion, payload.id, payload.data),
      call(backervoiceApi.pageVisitRedditConversion, payload.id, payload.data),
    ])

    yield put(
      getRedditConversionsSuccess(payload.id, [
        ...purchaseData,
        ...pageVisitData,
      ])
    )
  } catch (e) {
    yield put(getRedditConversionsFailed(e))
  }
}
